import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "@phosphor-icons/react";

const WA_URL = "https://wa.me/527223947826?text=Hola%2C%20quiero%20informaci%C3%B3n%20de%20las%20reuniones%20entre%20semana";

const cells = [
  {
    tag: "Reunión principal",
    big: "10:00",
    small: "AM — 12:00 PM",
    name: "Culto de Celebración · Domingo",
    desc: "Alabanza, palabra y comunión para toda la familia. Llega como estás.",
    testid: "horario-card-domingo",
  },
  {
    tag: "Oración",
    big: "6:00",
    small: "AM · Lunes",
    name: "Lunes de oración",
    desc: "Comenzamos cada semana de rodillas, presentando a Dios cada petición recibida. Vía Zoom.",
    testid: "horario-card-lunes",
  },
  {
    tag: "Entre semana",
    big: "Por",
    small: "anunciar",
    name: "Estudios y reuniones",
    desc: "Las reuniones entre semana se anuncian cada domingo y por WhatsApp.",
    href: WA_URL,
    cta: "Preguntar por WhatsApp",
    testid: "horario-card-entresemana",
  },
  {
    tag: "A distancia",
    big: "En",
    small: "vivo",
    name: "Transmisión dominical",
    desc: "Si no puedes acompañarnos en persona, únete al culto desde donde estés.",
    href: "#en-vivo",
    cta: "Ver transmisión",
    testid: "horario-card-envivo",
  },
];

const Horarios = () => (
  <section id="horarios" className="relative border-y border-white/10 bg-surface py-28 lg:py-36" data-testid="horarios-section">
    <span className="vertical-label absolute left-5 top-28 hidden text-[10px] font-light uppercase tracking-[0.5em] text-paper/30 xl:block">
      Reuniones
    </span>
    <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
      <div className="mb-16 grid gap-8 lg:grid-cols-2">
        <Reveal>
          <p className="mb-8 flex items-center gap-4 text-[10px] font-light uppercase tracking-[0.5em] text-fire" data-testid="horarios-eyebrow">
            <span className="inline-block h-px w-16 bg-fire" /> Horarios
          </p>
          <h2 className="font-serif text-5xl leading-[0.95] tracking-tight text-paper sm:text-7xl" data-testid="horarios-title">
            Hay un lugar <em className="italic text-gold">para ti</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="flex items-end">
          <p className="max-w-md text-sm font-light leading-relaxed tracking-wide text-smoke">
            No necesitas cita ni invitación. Nuestras puertas están abiertas cada semana en
            Nueva Oxtotitlán, Toluca. Ven con tu familia, con tus dudas, con tu cansancio: te esperamos.
          </p>
        </Reveal>
      </div>

      <div className="grid border border-white/10 md:grid-cols-2 md:divide-x md:divide-white/10 lg:grid-cols-4">
        {cells.map((c, i) => (
          <Reveal key={c.testid} delay={i * 0.1} className={`border-b border-white/10 last:border-b-0 md:border-b-0 ${i >= 2 ? "md:border-t lg:border-t-0" : ""} ${i % 2 === 1 ? "md:border-l-0 lg:border-l-0" : ""}`}>
            <div className="group flex h-full flex-col p-8 transition-colors duration-500 hover:bg-elevated lg:p-10" data-testid={c.testid}>
              <p className="text-[10px] font-light uppercase tracking-[0.4em] text-smoke">{c.tag}</p>
              <p className="mt-8 font-serif text-5xl leading-none text-paper lg:text-6xl">
                {c.big}
                <span className="mt-3 block font-serif text-xl italic text-gold">{c.small}</span>
              </p>
              <h3 className="mt-6 text-sm font-medium uppercase tracking-[0.2em] text-paper/90">{c.name}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-smoke">{c.desc}</p>
              {c.href && (
                <a
                  href={c.href}
                  target={c.href.startsWith("http") ? "_blank" : undefined}
                  rel={c.href.startsWith("http") ? "noopener noreferrer" : undefined}
                  onClick={c.href.startsWith("#") ? (e) => { e.preventDefault(); window.__lenis?.scrollTo(c.href, { offset: -60 }); } : undefined}
                  data-testid={`${c.testid}-cta`}
                  className="mt-auto inline-flex items-center gap-2 pt-8 text-[10px] font-medium uppercase tracking-[0.3em] text-paper/60 transition-colors duration-300 hover:text-fire"
                >
                  {c.cta} <ArrowUpRight size={14} weight="regular" />
                </a>
              )}
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-10 text-[10px] font-light uppercase tracking-[0.35em] text-paper/30" data-testid="horarios-note">
          Domingos 10:00 AM – 12:00 PM · Lunes de oración 6:00 AM vía Zoom · Laguna de las Palomas 304, Nueva Oxtotitlán, Toluca
        </p>
      </Reveal>
    </div>
  </section>
);

export default Horarios;
